import { initializeApp } from 'firebase/app'
import { getMessaging } from 'firebase/messaging'

const FIREBASE_CONFIG = {
  apiKey: 'AIzaSyA70qaJBhECrdJVOpaMsqfsdXLqC6BlGTo',
  authDomain: 'artemis-fcfad.firebaseapp.com',
  projectId: 'artemis-fcfad',
  storageBucket: 'artemis-fcfad.firebasestorage.app',
  messagingSenderId: '674328225046',
  appId: '1:674328225046:web:d363fee327acaff9489c37',
  measurementId: 'G-SWF1JRE1JH'
}

const DEFAULT_FCM_VAPID_KEY = 'BLHX51dLXp-D_ZTzzG5ZJmd14eXIs2oN2pfxniWvhlCHer5h6sSRWegPQLKUksPyHV1i_St_SpY2aFb90LFW1ek'

function sanitize(value) {
  return typeof value === 'string' ? value.trim() : ''
}

const isValidVapidKey = (value) => /^[A-Za-z0-9_-]{80,}$/.test(value)

const firebaseConfig = { ...FIREBASE_CONFIG }

// Config fija de Artemis para evitar mezclas de credenciales entre entornos.
const firebaseConfigSource = 'locked-artemis-config'

// Inicializar Firebase
const app = initializeApp(firebaseConfig)

// Inicializar Firebase Cloud Messaging y obtener referencia al servicio
// Nota: getMessaging() solo funciona en el cliente, no en SSR
let messaging = null
if (typeof window !== 'undefined') {
  try {
    messaging = getMessaging(app)
  } catch (err) {
    console.warn('Firebase Messaging no está disponible:', err)
  }
}

export function getFcmVapidKey() {
  const envVapid = sanitize(import.meta.env.VITE_FCM_VAPID_KEY)
  if (envVapid && isValidVapidKey(envVapid)) {
    return envVapid
  }
  return DEFAULT_FCM_VAPID_KEY
}

export default firebaseConfig
export { messaging }
export { firebaseConfigSource }

